import { OnInit } from '@angular/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
    model: any[] = [];
    models: any[] = [];
    ngOnInit() {
        this.model = [
            {
                label: 'Dashboards',
                icon: 'pi pi-home',
                items: [
                    {
                        label: 'E-Commerce',
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/'],
                    },
                    {
                        label: 'Banking',
                        icon: 'pi pi-fw pi-image',
                        routerLink: ['/dashboard-banking'],
                    },
                ],
            },
            {
                label: 'Apps',
                icon: 'pi pi-th-large',
                items: [
                    {
                        label: 'Blog',
                        icon: 'pi pi-fw pi-comment',
                        items: [
                            {
                                label: 'List',
                                icon: 'pi pi-fw pi-image',
                                routerLink: ['/apps/blog/list'],
                            },
                            {
                                label: 'Detail',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/apps/blog/detail'],
                            },
                            {
                                label: 'Edit',
                                icon: 'pi pi-fw pi-pencil',
                                routerLink: ['/apps/blog/edit'],
                            },
                        ],
                    },
                    {
                        label: 'Calendar',
                        icon: 'pi pi-fw pi-calendar',
                        routerLink: ['/apps/calendar'],
                    },
                    {
                        label: 'Chat',
                        icon: 'pi pi-fw pi-comments',
                        routerLink: ['/apps/chat'],
                    },
                    {
                        label: 'Files',
                        icon: 'pi pi-fw pi-folder',
                        routerLink: ['/apps/files'],
                    },
                    {
                        label: 'Kanban',
                        icon: 'pi pi-fw pi-sliders-v',
                        routerLink: ['/apps/kanban'],
                    },
                    {
                        label: 'Mail',
                        icon: 'pi pi-fw pi-envelope',
                        items: [
                            {
                                label: 'Inbox',
                                icon: 'pi pi-fw pi-inbox',
                                routerLink: ['/apps/mail/inbox'],
                            },
                            {
                                label: 'Compose',
                                icon: 'pi pi-fw pi-pencil',
                                routerLink: ['/apps/mail/compose'],
                            },
                            {
                                label: 'Detail',
                                icon: 'pi pi-fw pi-comment',
                                routerLink: ['/apps/mail/detail/1000'],
                            },
                        ],
                    },
                    {
                        label: 'Task List',
                        icon: 'pi pi-fw pi-check-square',
                        routerLink: ['/apps/tasklist'],
                    },
                ],
            },
            {
                label: 'UI Kit',
                icon: 'pi pi-fw pi-star-fill',
                items: [
                    {
                        label: 'Form Layout',
                        icon: 'pi pi-fw pi-id-card',
                        routerLink: ['/uikit/formlayout'],
                    },
                    {
                        label: 'Input',
                        icon: 'pi pi-fw pi-check-square',
                        routerLink: ['/uikit/input'],
                    },
                    {
                        label: 'Float Label',
                        icon: 'pi pi-fw pi-bookmark',
                        routerLink: ['/uikit/floatlabel'],
                    },
                    {
                        label: 'Invalid State',
                        icon: 'pi pi-fw pi-exclamation-circle',
                        routerLink: ['/uikit/invalidstate'],
                    },
                    {
                        label: 'Button',
                        icon: 'pi pi-fw pi-box',
                        routerLink: ['/uikit/button'],
                    },
                    {
                        label: 'Table',
                        icon: 'pi pi-fw pi-table',
                        routerLink: ['/uikit/table'],
                    },
                    {
                        label: 'List',
                        icon: 'pi pi-fw pi-list',
                        routerLink: ['/uikit/list'],
                    },
                    {
                        label: 'Tree',
                        icon: 'pi pi-fw pi-share-alt',
                        routerLink: ['/uikit/tree'],
                    },
                    {
                        label: 'Panel',
                        icon: 'pi pi-fw pi-tablet',
                        routerLink: ['/uikit/panel'],
                    },
                    {
                        label: 'Overlay',
                        icon: 'pi pi-fw pi-clone',
                        routerLink: ['/uikit/overlay'],
                    },
                    {
                        label: 'Media',
                        icon: 'pi pi-fw pi-image',
                        routerLink: ['/uikit/media'],
                    },
                    {
                        label: 'Menu',
                        icon: 'pi pi-fw pi-bars',
                        routerLink: ['/uikit/menu'],
                        routerLinkActiveOptions: {
                            paths: 'subset',
                            queryParams: 'ignored',
                            matrixParams: 'ignored',
                            fragment: 'ignored',
                        },
                    },
                    {
                        label: 'Message',
                        icon: 'pi pi-fw pi-comment',
                        routerLink: ['/uikit/message'],
                    },
                    {
                        label: 'File',
                        icon: 'pi pi-fw pi-file',
                        routerLink: ['/uikit/file'],
                    },
                    {
                        label: 'Chart',
                        icon: 'pi pi-fw pi-chart-bar',
                        routerLink: ['/uikit/charts'],
                    },
                    {
                        label: 'Misc',
                        icon: 'pi pi-fw pi-circle-off',
                        routerLink: ['/uikit/misc'],
                    },
                ],
            },
            {
                label: 'Prime Blocks',
                icon: 'pi pi-fw pi-prime',
                items: [
                    {
                        label: 'Free Blocks',
                        icon: 'pi pi-fw pi-eye',
                        routerLink: ['/blocks'],
                    },
                    {
                        label: 'All Blocks',
                        icon: 'pi pi-fw pi-globe',
                        url: ['https://www.primefaces.org/primeblocks-ng'],
                        target: '_blank',
                    },
                ],
            },
            {
                label: 'Utilities',
                icon: 'pi pi-fw pi-compass',
                items: [
                    {
                        label: 'PrimeIcons',
                        icon: 'pi pi-fw pi-prime',
                        routerLink: ['utilities/icons'],
                    },
                    {
                        label: 'Colors',
                        icon: 'pi pi-fw pi-palette',
                        routerLink: ['utilities/colors'],
                    },
                    {
                        label: 'PrimeFlex',
                        icon: 'pi pi-fw pi-desktop',
                        url: ['https://www.primefaces.org/primeflex/'],
                        target: '_blank',
                    },
                    {
                        label: 'Figma',
                        icon: 'pi pi-fw pi-pencil',
                        url: [
                            'https://www.figma.com/file/zQOW0XBXdCTqODzEOqwBtt/Preview-%7C-Apollo-2022?node-id=335%3A21768&t=urYI89V3PLNAZEJG-1/',
                        ],
                        target: '_blank',
                    },
                ],
            },
            {
                label: 'Pages',
                icon: 'pi pi-fw pi-briefcase',
                items: [
                    {
                        label: 'Landing',
                        icon: 'pi pi-fw pi-globe',
                        routerLink: ['/landing'],
                    },
                    {
                        label: 'Auth',
                        icon: 'pi pi-fw pi-user',
                        items: [
                            {
                                label: 'Login',
                                icon: 'pi pi-fw pi-sign-in',
                                routerLink: ['/auth/login'],
                            },
                            {
                                label: 'Error',
                                icon: 'pi pi-fw pi-times-circle',
                                routerLink: ['/auth/error'],
                            },
                            {
                                label: 'Access Denied',
                                icon: 'pi pi-fw pi-lock',
                                routerLink: ['/auth/access'],
                            },
                            {
                                label: 'Register',
                                icon: 'pi pi-fw pi-user-plus',
                                routerLink: ['/auth/register'],
                            },
                            {
                                label: 'Forgot Password',
                                icon: 'pi pi-fw pi-question',
                                routerLink: ['/auth/forgotpassword'],
                            },
                            {
                                label: 'New Password',
                                icon: 'pi pi-fw pi-cog',
                                routerLink: ['/auth/newpassword'],
                            },
                            {
                                label: 'Verification',
                                icon: 'pi pi-fw pi-envelope',
                                routerLink: ['/auth/verification'],
                            },
                            {
                                label: 'Lock Screen',
                                icon: 'pi pi-fw pi-eye-slash',
                                routerLink: ['/auth/lockscreen'],
                            },
                        ],
                    },
                    {
                        label: 'Crud',
                        icon: 'pi pi-fw pi-pencil',
                        routerLink: ['/pages/crud'],
                    },
                    {
                        label: 'Timeline',
                        icon: 'pi pi-fw pi-calendar',
                        routerLink: ['/pages/timeline'],
                    },
                    {
                        label: 'Invoice',
                        icon: 'pi pi-fw pi-dollar',
                        routerLink: ['/pages/invoice'],
                    },
                    {
                        label: 'About Us',
                        icon: 'pi pi-fw pi-user',
                        routerLink: ['/pages/aboutus'],
                    },
                    {
                        label: 'Help',
                        icon: 'pi pi-fw pi-question-circle',
                        routerLink: ['/pages/help'],
                    },
                    {
                        label: 'Not Found',
                        icon: 'pi pi-fw pi-exclamation-circle',
                        routerLink: ['/pages/notfound'],
                    },
                    {
                        label: 'Empty',
                        icon: 'pi pi-fw pi-circle-off',
                        routerLink: ['/pages/empty'],
                    },
                    {
                        label: 'FAQ',
                        icon: 'pi pi-fw pi-question',
                        routerLink: ['/pages/faq'],
                    },
                    {
                        label: 'Contact Us',
                        icon: 'pi pi-fw pi-phone',
                        routerLink: ['/pages/contact'],
                    },
                ],
            },
            {
                label: 'E-Commerce',
                icon: 'pi pi-fw pi-wallet',
                items: [
                    {
                        label: 'Product Overview',
                        icon: 'pi pi-fw pi-image',
                        routerLink: ['ecommerce/product-overview'],
                    },
                    {
                        label: 'Product List',
                        icon: 'pi pi-fw pi-list',
                        routerLink: ['ecommerce/product-list'],
                    },
                    {
                        label: 'New Product',
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['ecommerce/new-product'],
                    },
                    {
                        label: 'Shopping Cart',
                        icon: 'pi pi-fw pi-shopping-cart',
                        routerLink: ['ecommerce/shopping-cart'],
                    },
                    {
                        label: 'Checkout Form',
                        icon: 'pi pi-fw pi-check-square',
                        routerLink: ['ecommerce/checkout-form'],
                    },
                    {
                        label: 'Order History',
                        icon: 'pi pi-fw pi-history',
                        routerLink: ['ecommerce/order-history'],
                    },
                    {
                        label: 'Order Summary',
                        icon: 'pi pi-fw pi-file',
                        routerLink: ['ecommerce/order-summary'],
                    },
                ],
            },
            {
                label: 'User Management',
                icon: 'pi pi-fw pi-user',
                items: [
                    {
                        label: 'List',
                        icon: 'pi pi-fw pi-list',
                        routerLink: ['profile/list'],
                    },
                    {
                        label: 'Create',
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['profile/create'],
                    },
                ],
            },
            {
                label: 'Hierarchy',
                icon: 'pi pi-fw pi-align-left',
                items: [
                    {
                        label: 'Submenu 1',
                        icon: 'pi pi-fw pi-align-left',
                        items: [
                            {
                                label: 'Submenu 1.1',
                                icon: 'pi pi-fw pi-align-left',
                                items: [
                                    {
                                        label: 'Submenu 1.1.1',
                                        icon: 'pi pi-fw pi-align-left',
                                    },
                                    {
                                        label: 'Submenu 1.1.2',
                                        icon: 'pi pi-fw pi-align-left',
                                    },
                                    {
                                        label: 'Submenu 1.1.3',
                                        icon: 'pi pi-fw pi-align-left',
                                    },
                                ],
                            },
                            {
                                label: 'Submenu 1.2',
                                icon: 'pi pi-fw pi-align-left',
                                items: [
                                    {
                                        label: 'Submenu 1.2.1',
                                        icon: 'pi pi-fw pi-align-left',
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        label: 'Submenu 2',
                        icon: 'pi pi-fw pi-align-left',
                        items: [
                            {
                                label: 'Submenu 2.1',
                                icon: 'pi pi-fw pi-align-left',
                                items: [
                                    {
                                        label: 'Submenu 2.1.1',
                                        icon: 'pi pi-fw pi-align-left',
                                    },
                                    {
                                        label: 'Submenu 2.1.2',
                                        icon: 'pi pi-fw pi-align-left',
                                    },
                                ],
                            },
                            {
                                label: 'Submenu 2.2',
                                icon: 'pi pi-fw pi-align-left',
                                items: [
                                    {
                                        label: 'Submenu 2.2.1',
                                        icon: 'pi pi-fw pi-align-left',
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                label: 'Start',
                icon: 'pi pi-fw pi-download',
                items: [
                    {
                        label: 'Buy Now',
                        icon: 'pi pi-fw pi-shopping-cart',
                        url: ['https://www.primefaces.org/store'],
                    },
                    {
                        label: 'Documentation',
                        icon: 'pi pi-fw pi-info-circle',
                        routerLink: ['/documentation'],
                    },
                ],
            },
        ];

        //TODO AFTCH
        this.model = [
            {
                label: 'Gestión Legajo Personal',
                icon: 'pi pi-fw pi-user',
                items: [
                    {
                        label: 'Mantenimiento',
                        icon: 'pi pi-cog',
                        items: [
                            {
                                label: 'Dominio',
                                icon: 'pi pi-fw pi-home',
                                routerLink: ['/pages/dominio'],
                            },
                            {
                                label: 'Parametros',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/pages/parametro'],
                            },
                        ],
                    },
                    {
                        label: 'Legajo',
                        icon: 'pi pi-fw pi-user',
                        items: [
                            {
                                label: 'Información Personal y familiar',
                                icon: 'pi pi-fw pi-users',
                                routerLink: ['/pages/empleado'],
                            },
                            {
                                label: 'Incorporación',
                                icon: 'pi pi-fw pi-user-plus',
                                items: [
                                    {
                                        label: 'Contrato',
                                        icon: 'pi pi-fw pi-file',
                                        routerLink: ['/pages/crud'],
                                    },
                                    {
                                        label: 'Inducción',
                                        icon: 'pi pi-fw pi-file',
                                        routerLink: ['/uikit/button'],
                                    },
                                    {
                                        label: 'Periodo de Prueba',
                                        icon: 'pi pi-fw pi-calendar',
                                        routerLink: ['/uikit/button'],
                                    },
                                ],
                            },
                            {
                                label: 'Compensaciones',
                                icon: 'pi pi-fw pi-file',
                                routerLink: ['/uikit/button'],
                            },
                            {
                                label: 'Evaluación de Desempeño',
                                icon: 'pi pi-fw pi-file',
                                routerLink: ['/uikit/button'],
                            },
                            {
                                label: 'Reconocimientos y Sanciones Disciplinarias',
                                icon: 'pi pi-fw pi-file',
                                routerLink: ['/uikit/button'],
                            },
                            {
                                label: 'Desvinculación',
                                icon: 'pi pi-fw pi-file',
                                routerLink: ['/uikit/button'],
                            },
                        ],
                    },
                    {
                        label: 'Reportes',
                        icon: 'pi pi-fw pi-chart-bar',
                        items: [
                            {
                                label: 'Ficha Personal',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/uikit/input'],
                            },
                        ],
                    },
                ],
            },
            {
                label: 'Gestión de Planillas',
                icon: 'pi pi-fw pi-dollar',
                items: [
                    {
                        label: 'Mantenimiento',
                        icon: 'pi pi-fw pi-cog',
                        items: [
                            {
                                label: 'Dominio',
                                icon: 'pi pi-fw pi-home',
                                routerLink: ['/ecommerce/new-product'],
                            },
                            {
                                label: 'Parametros',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/ecommerce/new-product'],
                            },
                            {
                                label: 'Conceptos remunerativos',
                                icon: 'pi pi-fw pi-money-bill',
                                routerLink: ['/ecommerce/new-product'],
                            },
                            {
                                label: 'Descuentos Judiciales',
                                icon: 'pi pi-fw pi-percentage',
                                routerLink: ['/ecommerce/new-product'],
                            },
                            {
                                label: 'Aportaciones y Retenciones',
                                icon: 'pi pi-fw pi-percentage',
                                routerLink: ['/ecommerce/new-product'],
                            },
                            {
                                label: 'Fórmulas',
                                icon: 'pi pi-fw pi-wrench',
                                routerLink: ['/ecommerce/new-product'],
                            },
                            {
                                label: 'Clasificador de Gastos',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/ecommerce/new-product'],
                            }
                        ],
                    },
                    {
                        label: 'Planillas',
                        icon: 'pi pi-fw pi-money-bill',
                        items: [
                            {
                                label: 'Generación de Planillas',
                                icon: 'pi pi-fw pi-eject',
                                routerLink: ['/ecommerce/new-product'],
                            },
                            {
                                label: 'Descuentos Externos',
                                icon: 'pi pi-fw pi-file-import',
                                routerLink: ['/profile/list'],
                            },
                            {
                                label: 'Voladores',
                                icon: 'pi pi-fw pi-bolt',
                                routerLink: ['/ecommerce/new-product'],
                            },
                            {
                                label: 'Generación de Archivo MCPP-SIAF',
                                icon: 'pi pi-fw pi-file-export',
                                routerLink: ['/profile/list'],
                            },
                        ],
                    },
                    {
                        label: 'Reportes',
                        icon: 'pi pi-th-large',
                        items: [
                            {
                                label: 'Planilla de Pagos',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/ecommerce/new-product'],
                            },
                            {
                                label: 'Cadena presupuestal y clasificador de gasto',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/profile/list'],
                            },
                            {
                                label: 'Descuento 4ta. Cat.',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/apps/files'],
                            },
                            {
                                label: 'Personal x Meta',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/uikit/misc'],
                            },
                            {
                                label: 'Planilla x Meta',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/uikit/table'],
                            },
                            {
                                label: 'AFP x Meta',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Planilla x Banco Meta',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Reporte Anual (mensualizado) de la planilla',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Planilla Total x Concepto',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Resumen Planilla',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Resumen Planilla x AFP',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Resumen General x banco - Fuente Financiamiento - AFP - Meta',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'AFP Net',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Resumen General x Fuente Financiamiento - AFP - Meta',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Resumen de Retenciones x Cuotas Pat. x Fuente Financiamiento - Meta',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Resumen de Retenciones x Fuente Financiamiento - Meta - Partida - Concepto',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Resumen General Retenciones x Fuente Financiamiento - AFP - Meta',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Concepto y Meta',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Transparencia',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Boleta de Pago',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Cuadro Anual x Trabajador',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Cuadro Mensual de Concepto de Egreso',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Cuadro Anual x Concepto',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Personal x Sede',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Conceptos de Retención x AFP y Sub Planilla',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Conceptos de Retención 4ta. Cat.',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                            {
                                label: 'Conceptos de Retención x AFP Planilla',
                                icon: 'pi pi-fw pi-chart-bar',
                                routerLink: ['/pages/parametro'],
                            },
                        ],
                    },
                ],
            },
            {
                label: 'Control de Asistencia',
                icon: 'pi pi-fw pi-verified',
                items: [
                    {
                        label: 'Mantenimiento',
                        icon: 'pi pi-th-large',
                        items: [
                            {
                                label: 'Feriados',
                                icon: 'pi pi-fw pi-home',
                                routerLink: ['/pages/dominio'],
                            },
                            {
                                label: 'Turnos',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/pages/parametro'],
                            },
                        ],
                    },
                    {
                        label: 'Reportes',
                        icon: 'pi pi-fw pi-chart-bar',
                        items: [
                            {
                                label: 'Marcaciones Diarias',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/apps/blog/list'],
                            },
                            {
                                label: 'Detalle Tardanzas',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/apps/blog/list'],
                            },
                            {
                                label: 'Detalle Faltas',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/apps/blog/list'],
                            },
                            {
                                label: 'Justificaciones',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/apps/blog/list'],
                            },
                            {
                                label: 'General de Puntualidad',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/apps/blog/list'],
                            },
                            {
                                label: 'Personal Activo sin Turno',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/apps/blog/list'],
                            },
                            {
                                label: 'Por Concepto',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/apps/blog/list'],
                            },
                            {
                                label: 'Horas Extras',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/apps/blog/list'],
                            },
                            {
                                label: 'x Tiempo de Tardanza',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/apps/blog/list'],
                            },
                            {
                                label: 'Horario Asignado pero sin Marca',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/apps/blog/list'],
                            },
                            {
                                label: 'General con Horario y Marca',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/apps/blog/list'],
                            },
                        ],
                    },
                ],
            },
        ];
    }
}
